import type {RouteRecordRaw} from "vue-router";

// Sem entradas no catálogo EPermissao ainda (nenhuma foi registrada no backend para Boleto/Convênio)
// — por decisão do usuário, as rotas ficam só com authRequired até que códigos reais existam.
// Ver plano em for_claude (Boleto) e revisar quando o catálogo for criado.
export const boletoRoutes: RouteRecordRaw[] = [
    {
        path: "/boleto/convenio",
        name: "boleto-convenio",
        meta: {authRequired: true},
        component: () => import("@/modules/boleto/pages/PageConvenio.vue")
    },
    {
        path: "/boleto",
        name: "boleto",
        meta: {authRequired: true},
        component: () => import("@/modules/boleto/pages/PageBoleto.vue")
    },
    {
        path: "/boleto/remessa",
        name: "boleto-remessa",
        meta: {authRequired: true},
        component: () => import("@/modules/boleto/pages/PageBoletoRemessa.vue")
    },
    {
        path: "/boleto/retorno",
        name: "boleto-retorno",
        meta: {authRequired: true},
        component: () => import("@/modules/boleto/pages/PageBoletoRetorno.vue")
    },
];
